VjsAdmin.Login = (function () {
    let checkTimer = null;
    let lastChecked = null;

    // POD-3278: as the username is typed, ask the server whether the password field applies to it.
    // A Google-only account ("Form Login Allowed" off) gets a "use Google Login" notice instead of the password box.
    const applyFormCheck = function (allowed) {
        $('#password-fields').toggleClass('is-hidden', !allowed);
        $('#sso-only').toggleClass('is-hidden', allowed);
        $('#password').prop('disabled', !allowed);
    };

    const checkUsername = function () {
        const $form = $('form.login-card');
        const url = $form.data('formCheckUrl');
        const username = ($('#username').val() || '').trim();

        if (!url || $('#sso-only').length === 0) {
            return;
        }
        if (username === '' || username === lastChecked) {
            if (username === '') {
                applyFormCheck(true);
                lastChecked = null;
            }
            return;
        }
        lastChecked = username;

        const isStillCurrent = () => (($('#username').val() || '').trim() === username);

        $.post(url, { username })
            .done((res) => {
                // responses for two quickly typed usernames can arrive out of order; only the one for
                // the username still in the box may change the form
                if (!isStillCurrent()) {
                    return;
                }
                applyFormCheck(!(res && res.form_allowed === false));
            })
            .fail(() => {
                if (!isStillCurrent()) {
                    return;
                }
                lastChecked = null; // let a later blur/change retry
                applyFormCheck(true); // never lock someone out because the check itself failed
            });
    };

    const init = function () {
        const $username = $('#username');
        if ($username.length === 0) {
            return;
        }

        $username.on('input', () => {
            clearTimeout(checkTimer);
            checkTimer = setTimeout(checkUsername, 400);
        });
        $username.on('blur change', checkUsername);

        // the browser may have autofilled the username before we attached the handlers
        if (($username.val() || '').trim() !== '') {
            checkUsername();
        }
    };

    return {
        init,
    };
}());
